import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { firstValueFrom } from 'rxjs'
import { AppState } from '../core/store'
import { selectIsAuthorized } from '../core/store/auth/auth.selectors'

export const roleGuard: CanActivateFn = async () => {
  const store = inject(Store<AppState>)
  const router = inject(Router)

  const authorized = await firstValueFrom(store.select(selectIsAuthorized))

  return authorized ? true : router.parseUrl('/access-denied')
}
